<template>
  <section class="news-top-data" v-if="data">
    <section class="news-top-data-header">
      <span class="header-level" :class="newsStates[data.type]">{{data.typeName}}</span>
      <time class="header-date">{{data.createDate | fromatTime}}</time>
      <span class="header-icon">{{ $t('top-news.top') }}</span>
    </section>
    <section class="news-top-data-main">
      <a :href="$i18n.path(`news/${data.id}`)" target="_blank">
        <h2 class="main-header">
          {{data.title}}
        </h2>
        <p class="main-des">
          {{data.content}}
        </p>
      </a>
    </section>
    <section class="news-top-data-share">
      <span class="share-link" v-if='data.link'>
        <!-- TODO: 这玩意是啥？需不需要i18n？ -->
        <a :href="data.link">{{ $t('top-news.source') }}:{{data.linkName}}</a>
      </span>
      <span class="share-icon">
          <!--<share :NewId='data.id' :title='data.title' :summary='data.content'></share>-->
      </span>
    </section>
  </section>
</template>
<script>
  import allStates from '~/plugins/allStates'
  import { parseTime } from '~/plugins/filters'
  export default {
    name: 'top-news',
    data() {
      return {
        newsStates: {}
      }
    },
    props: ['topdata'],
    computed: {
      data() {
        return this.topdata
      }
    },
    filters:{
    },
    created() {
      this.newsStates = allStates.newsStates
    },
    methods: {
    },
    watch: {
    },
    components: {
    }
  }

</script>
<style lang="less" scoped>
  .news-top-data {
    width: 860px;
    height: 188px;
    padding: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background: #ffffff;
    .news-top-data-header{
      .header-date {
        color: #838d97;
        font-size: 12px;
        padding: 0 10px;
      }
      .header-level {
        display: inline-block;
        font-size: 14px;
        line-height: 28px;
        height: 28px;
        width: 91px;
        color: white;
        text-align: center;
        border-radius: 14px;
      }
      .header-icon {
        float: right;
        color: #fb4a2c;
        font-size: 12px;
        img {
          vertical-align: middle;
          padding: 0 10px;
        }
      }
    }

    .news-top-data-main {
      padding: 10px 0px;
      a {
        color:#333;
        .main-header {
          font-weight: bolder;
          font-size:16px;
          margin: 10px 0;
          height: 36px;
          line-height: 1.3;
          overflow: hidden;
        }
        .main-des {
          font-size: 12px;
          color: #838d97;
          line-height: 1.5;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 36px;
        }
      }
    }
    .news-top-data-share {
      font-size: 12px;
      line-height: 21px;
      height: 21px;
      overflow: hidden;
      clear: both;
      _zoom: 1;
      .share-icon {
        float: right;
        }
      .share-link a {
        color: #3175d1;
      }
    }
    .type-news {
      background: #e45d5b
    }

    .type-unusal {
      background: #ca5ba0
    }

    .type-level {
      background: #63c7dd
    }

    .type-summary {
      background: #559ae2
    }

    .type-event {
      background: #e31818
    }
}



</style>
